document.addEventListener( 'DOMContentLoaded', () => {
	const grids = document.querySelectorAll( '.programs-grid' );

	grids.forEach( ( grid ) => {
		const wrapper = grid.parentElement.querySelector( '.programs-load-more-wrapper' );
		const button = wrapper?.querySelector( '.programs-load-more-btn' );

		if ( ! wrapper || ! button ) {
			return;
		}

		const loadStep = parseInt( grid.dataset.loadStep, 10 ) || 12;

		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			if ( wrapper.classList.contains( 'is-loading' ) ) {
				return;
			}

			wrapper.classList.add( 'is-loading' );

			setTimeout( () => {
				const hiddenCards = grid.querySelectorAll( '.programs-card.is-hidden' );

				Array.from( hiddenCards )
					.slice( 0, loadStep )
					.forEach( ( card ) => {
						card.classList.remove( 'is-hidden' );
					} );

				if ( ! grid.querySelector( '.programs-card.is-hidden' ) ) {
					wrapper.style.display = 'none';
				} else {
					wrapper.classList.remove( 'is-loading' );
				}
			}, 2500 );
		} );
	} );
} );
